import React from 'react';
// import Highcharts from 'highcharts';
import { observer, inject } from 'mobx-react';
import { action, observable, toJS } from 'mobx';
import moment from 'moment';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as api from '../../../actions/api';
import { getDisplayDate } from '../../../libs/date';
import _ from 'lodash';
import GraphView from '../../GraphView';
// import Form from '../../Form';
import Spinner from '../../Spinner';


@inject('stationStore', 'dataSeriesStore')
@observer
class HydrologygraphView extends React.Component {
  @observable loading = false;
  @observable options = null
  @observable filtersvalue = null
  constructor(props) {
    super(props);
    this.state = {
      data: {
        seriesData: []
      },
    };
  }

  componentWillMount() {
    const { stationStore, params: { id } } = this.props;
    // if (!stationStore.items.length && !stationStore.isLoading) stationStore.fetchItems();
    stationStore.fetchItem(id, true).then(() => this.showObservations());
  }

  @action showObservations = (e) => {
    const { stationStore, params: { id } } = this.props;
    this.loading = true
    let filters = {
      stations: id,
      parameters: '22',
      date_from: moment().add(-15, 'days').format('YYYY-MM-DD'),
      date_to: moment().format('YYYY-MM-DD'),
    };
    this.filtersvalue = filters
    api.analysis.fetchMore(filters)
      .then((res) => {
        let observations = res[0].parameters.find(item => +item.parameter_id === 22);
        let seriesData = (
          !!observations.data &&
          observations.data.map(({ time, value }) => [getDisplayDate(time, { returnMills: true }), value])
        ) || [];
        console.log(seriesData)
        this.setState({
          data: observations.data,
          seriesData
        }, () => {
          let stationItem = stationStore.findById(id).asJson;
          let dangerLevel = !!stationItem.meta_data && stationItem.meta_data.find(item => item.name === 'Danger Level')
          const options = {
            chart: {
              type: 'line',
              zoomType: 'x',
            },
            title: {
              text: stationItem.name,
            },
            xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                millisecond: '%H:%M:%S.%L',
                second: '%H:%M:%S',
                minute: '%H:%M',
                hour: '%H:%M',
                day: '%e. %b',
                week: '%e. %b',
                month: '%b \'%y',
                year: '%Y'
              },
              title: {
                text: 'Date',
              },
            },
            yAxis: {
              title: {
                text: `${observations.parameter_unit} (${observations.parameter_unit_symbol})`,
              },
              // min: !!dangerLevel && !!dangerLevel.value ? +dangerLevel.value - 1.1 : 'unset',
              // max: !!dangerLevel && !!dangerLevel.value ? +dangerLevel.value + 1.1 : 'unset',
              plotLines: !!dangerLevel && !!dangerLevel.value ? [
                {
                  value: +dangerLevel.value - 0.5,
                  zIndex: 2,
                  width: 1,
                  color: 'yellow',
                  label: {
                    text: 'Warning',
                  }
                },
                {
                  value: +dangerLevel.value,
                  zIndex: 2,
                  width: 1,
                  color: 'orange',
                  label: {
                    text: "Danger",
                  }
                },
                {
                  value: +dangerLevel.value + 1,
                  zIndex: 2,
                  width: 1,
                  color: 'red',
                  label: {
                    text: 'HFL',
                  }
                }
              ] : []
            },
            series: [{
              name: observations.name,
              data: seriesData
            }]
          };
          this.options = options;
          this.loading = false;
        });
      })
      .catch(err => {
        this.loading = false;
        console.log('err', err);
      });

  }
  @action exportPDF = (e) => {
    const { stationStore } = this.props
    e.preventDefault();
    let doc = new jsPDF();
    const titleText = `${stationStore.findById(this.filtersvalue.stations).name} from ${this.filtersvalue.date_from} to ${this.filtersvalue.date_to}`;
    let textToSave = [];
    this.state.seriesData.forEach((d, index) => {
      if (index > 0 && index < this.state.seriesData.length - 1) {
        let datetime = moment.utc(d[0]).format('YYYY-MM-DD HH:mm:ss'),
          value = !!d[1] || d[1] === 0 ? d[1] : '';
        textToSave.push([datetime, value])
      }
    });
    doc.autoTable({
      head: [["dateTime", "value"]],
      body: textToSave,
    })

    doc.save(titleText + '.pdf')
  }
  render() {
    if (this.loading || !this.options) return <Spinner />
    let options = toJS(this.options)
    console.log(options);
    return (
      <div>
        {/* <Form>
          {<button onClick={this.exportPDF}>Download PDF </button>}
        </Form> */}
        <GraphView options={options} />
      </div>
    );
  }
}

export default HydrologygraphView


// WEBPACK FOOTER //
// ./src/components/Analysis/Hydrology/HydrologyGraph.js